import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { TradingOfferTimelineStep } from '../../../types/TradingOffer';

type TradingOfferTimelineProps = {
  steps: TradingOfferTimelineStep[];
};

const TradingOfferTimeline: FC<TradingOfferTimelineProps> = ({ steps }) => {
  const { t } = useTranslate();

  const getStepClass = (step: TradingOfferTimelineStep) => {
    if (step.isCompleted) return 'completed';
    if (step.isCurrent) return 'current';
    return '';
  };

  return (
    <div className="card card-bordered">
      <div className="card-inner">
        <h6 className="card-title text-base">{t('OfferTimeline')}</h6>

        <ul className="nk-stepper-nav">
          {steps.map((step, index) => (
            <li
              key={step.key}
              className={`nk-stepper-item ${getStepClass(step)}`}
            >
              <div className="step-icon">
                {step.isCompleted ? (
                  <em className="icon ni ni-check" />
                ) : (
                  <span>{index + 1}</span>
                )}
              </div>
              <div className="step-text">
                <span className="lead-text">{t(step.label)}</span>
                {step.date && <span className="sub-text">{step.date}</span>}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default TradingOfferTimeline;
